var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.longLoading)?_c('loadingOverlay'):_vm._e(),_c('deckglCanvas',{on:{"long-loading-finished":function($event){_vm.longLoading = false}}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }